import styled, { css } from 'styled-components/macro';
import { ReactComponent as Chevron } from '../assets/icons/chevron-down.svg';

export const DropdownContainer = styled.div`
  position: relative;
  background-color: transparent;
  cursor: default;
  white-space: nowrap;
  user-select: none;
  margin: 20px 0;
  outline: none;
  ${props => props.theme.fontStackHeader};
  font-style: normal;
  height: 4.4rem;
  ${props =>
    props.disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.5;
    `}
  ${props =>
    props.noLabel &&
    css`
      height: 3rem;
    `}
`;

export const Label = styled.label`
  transition: all 0.2s ease;
  transform: translate(0, 0);
  user-select: none;
  z-index: 0;
  font-size: 1.3rem;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 1.5rem;
  padding-bottom: 1px;
  ${props => props.disabled && 'cursor: not-allowed;'};
  ${props =>
    props.floatingLabel
      ? css`
          font-weight: 600;
          text-transform: uppercase;
        `
      : css`
          transform: translate(0, 150%);
          color: ${props.theme.dustierGray};
          font-weight: 300;
        `}
`;

export const DropdownTitleDiv = styled.div`
  width: 100%;
  height: 3rem;
  line-height: 3rem;
  border-bottom: 1px solid ${props => props.theme.mercury};
  ${props => props.theme.fontStackBody};
  font-size: 1.4rem;
  ${props =>
    props.readOnly &&
    css`
      border-bottom-color: transparent;
    `}
  font-weight: 400;
  ${props =>
    props.open &&
    css`
      border-bottom: 2px solid ${props.theme.blue};
      border-top: 1px solid transparent;
      line-height: 2.8rem;
    `}
  ${props =>
    !props.selectedOptionValue &&
    css`
      color: ${props.theme.dustierGray};
      font-size: 1.3rem;
      font-weight: 300;
    `}

  ${props =>
    props.meta &&
    props.meta.touched &&
    props.meta.error &&
    css`
      border-bottom-color: ${props => props.theme.red};
    `}
`;

export const DropdownTextInput = styled.input`
  width: 100%;
  height: 100%;
  line-height: 30px;
  font-weight: 400;
  padding: 0;
  outline: none;
  border: none;
`;

export const ItemLi = styled.li`
  height: 2.4rem;
  padding: 0.3rem 1rem;
  font-weight: 400;
  &:hover {
    color: ${props => props.theme.blue};
  }
  ${props =>
    props.index === props.highlighted
      ? css`
          background-color: ${props.theme.concrete};
        `
      : ''}
  ${'' /* else should be dropdown-option but there is no singular of that class */}
`;

export const DropdownOptionsDiv = styled.div`
  position: absolute;
  top: 100%;
  max-height: 200px;
  overflow-y: scroll;
  scrollbar-width: none; /* firefox */
  -webkit-overflow-scrolling: touch;
  left: 0;
  transform: translateY(-50%) scaleY(0);
  transition: transform 0.2s ease;
  background-color: white;
  width: 100%;
  box-sizing: border-box;
  ${props => props.theme.defaultDropShadow};
  border-top: none;
  z-index: 2;
  font-weight: 300;
  font-size: 1.3rem;
  & > ul {
    padding: 10px 0;
  }
  &::-webkit-scrollbar {
    display: none;
  }
  ${props => props.open && 'transform: translateY(0) scaleY(1);'};
`;

export const ChevronSvg = styled(Chevron)`
  fill: ${props => props.theme.black};
  width: 20px;
  position: absolute;
  top: 2.4rem;
  right: 0;
  font-size: 0.6rem;
  padding: 0px 5px;
  ${props =>
    props.styled.noLabel &&
    css`
      top: 1.4rem;
    `}
  ${props =>
    props.meta &&
    props.meta.touched &&
    props.meta.error &&
    css`
      fill: ${props => props.theme.red};
    `}
    ${props =>
      props.readOnly &&
      css`
        width: 0px;
      `}
`;
ChevronSvg.defaultProps = { styled: {} };
